import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SearchEnhanced from './pages/SearchEnhanced';
import Library from './pages/Library';
import VibePage from './pages/VibePage';
import AllVibes from './pages/AllVibes';
import AllMusicPage from './pages/AllMusicPage';
import LikedSongs from './pages/LikedSongs';
import MadeForYou from './pages/MadeForYou';
import NewSongs from './pages/NewSongs';
import TrendingSongs from './pages/TrendingSongs';
import AllGenres from './pages/AllGenres';
import GenrePage from './pages/GenrePage';
import Login from './pages/Login';
import Profile from './pages/Profile';
import SocialFeed from './SocialFeed';
import UserProfile from './pages/UserProfile';
import SharedSong from './pages/SharedSong';
import SharedPlaylist from './pages/SharedPlaylist';
import ExplorePublicPlaylists from './pages/ExplorePublicPlaylists';
import PlaylistPage from './pages/PlaylistPage';
import ListeningHistory from './pages/ListeningHistory';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import TopBar from './TopBar';

const MainContent = ({ 
  playSong, 
  songs, 
  vibes, 
  playlists, 
  likedSongs, 
  toggleLike, 
  user, 
  setUser,
  setIsAdmin,
  onLogout 
}) => {
  return (
    <div className="main-content">
      <TopBar user={user} />
      <div className="main-content-inner">
        <Routes>
          <Route 
            path="/" 
            element={
              <Home 
                playSong={playSong}
                songs={songs}
                vibes={vibes}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/search" 
            element={
              <SearchEnhanced 
                playSong={playSong}
                songs={songs}
                vibes={vibes}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/made-for-you" 
            element={
              <MadeForYou 
                playSong={playSong}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/new-songs" 
            element={
              <NewSongs 
                playSong={playSong}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/trending" 
            element={
              <TrendingSongs 
                playSong={playSong}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/library" 
            element={
              <Library 
                playSong={playSong}
                songs={songs}
                playlists={playlists}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
                vibes={vibes}
              />
            } 
          />
          <Route 
            path="/vibes" 
            element={
              <AllVibes 
                playSong={playSong}
                songs={songs}
                vibes={vibes}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/all-music" 
            element={
              <AllMusicPage 
                playSong={playSong}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/vibe/:vibeId" 
            element={
              <VibePage 
                playSong={playSong}
                songs={songs}
                vibes={vibes}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/genres" 
            element={
              <AllGenres 
                songs={songs}
              />
            } 
          />
          <Route 
            path="/genre/:genreSlug" 
            element={
              <GenrePage 
                playSong={playSong}
                songs={songs}
                user={user}
              />
            } 
          />
          <Route 
            path="/explore-playlists" 
            element={
              <ExplorePublicPlaylists 
                user={user}
              />
            } 
          />
          <Route 
            path="/liked" 
            element={
              <LikedSongs 
                playSong={playSong}
                songs={songs}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/history" 
            element={
              <ListeningHistory 
                playSong={playSong}
                likedSongs={likedSongs}
                toggleLike={toggleLike}
                user={user}
              />
            } 
          />
          <Route 
            path="/login" 
            element={
              <Login 
                setUser={setUser}
                setIsAdmin={setIsAdmin}
              />
            } 
          />
          <Route 
            path="/profile" 
            element={
              <Profile 
                user={user}
                onLogout={onLogout}
              />
            } 
          />
          <Route 
            path="/social" 
            element={
              <SocialFeed user={user} />
            } 
          />
          <Route 
            path="/user/:userId" 
            element={
              <UserProfile currentUser={user} />
            } 
          />
          <Route 
            path="/song/:songId" 
            element={
              <SharedSong 
                playSong={playSong}
                songs={songs}
                toggleLike={toggleLike}
                likedSongs={likedSongs}
                user={user}
              />
            } 
          />
          <Route 
            path="/shared/playlist/:shareToken" 
            element={
              <SharedPlaylist 
                playSong={playSong}
                toggleLike={toggleLike}
                likedSongs={likedSongs}
                user={user}
              />
            } 
          />
          <Route 
            path="/playlist/:playlistId" 
            element={
              <PlaylistPage 
                songs={songs}
                playSong={playSong}
                toggleLike={toggleLike}
                likedSongs={likedSongs}
                user={user}
              />
            } 
          />
          <Route 
            path="/terms" 
            element={<Terms />} 
          />
          <Route 
            path="/privacy" 
            element={<Privacy />} 
          />
        </Routes>
      </div>
    </div>
  );
};

export default MainContent;
